import { useEffect, useMemo, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import SalePOSPrint from "./SalePOSPrint";
import { formatNumber } from "../../helpers/common";
import httpClient from "../../provider/httpClient";


const SaleView = () => {
  const printableArea = useRef();
  const [isPrinting, setIsPrinting] = useState(false);
  const posPrintRef = useRef(null);
  // We store the resolve Promise being used in `onBeforePrint` here
  const promiseResolveRef = useRef(null);

  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState(null);
  const [businessData, setBusinessData] = useState(null);
  const [rows, setRows] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  // const [grandTotal, setGrandTotal] = useState(0.00);

  // const navigate = useNavigate();
  const formID = searchParams.get("form_id");

  useEffect(() => {
    if (formID > 0) {
      setDataLoaded(false);
      fetchData(formID);
      fetchBusinessInfo();
    }
  }, [formID]);

  useEffect(() => {
    console.log("rows   d: ", rows);
    // calculateSummary();
  }, [rows]);

  useEffect(() => {
    console.log("formdata updated: ", formData, dataLoaded);
  }, [formData]);

  // We watch for the state to change here, and for the Promise resolve to be available
  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const fetchData = async (formID) => {
    try {
      const response = await httpClient.get(
        `/sale/${formID}`
      );
      const results = await response.data.data;
      setFormData(results);
      setRows(results.sale_details);
      // setGrandTotal(results.total_amount);
      console.log("setting initial rows ", results.sale_details);
      setDataLoaded(true);
    } catch (error) {
      console.error(error);
    }
  }

  const fetchBusinessInfo = async () => {
    try {
      const response = await httpClient.get(`/setting`);
      setBusinessData(response.data.data);
    }
    catch (error) {
      console.log(error);
    }
  }

  const handlePrint = useReactToPrint({
    content: () => printableArea.current,
  });

  const handlePOSPrint = useReactToPrint({
    content: () => posPrintRef.current,
    onBeforePrint: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
      });
    },
    onAfterPrint: () => {
      // Reset the Promise resolve so we can print again
      promiseResolveRef.current = null;
      setIsPrinting(false);
    }
  });

  const columns = useMemo(
    () => [
      {
        name: "Product",
        cell: (row, index) => (
          <>
            {row.product.product_name}
            <span className="badge badge-success" style={{ marginLeft: "5px" }}>{row.product.product_code}</span>
          </>
        ),
        wrap: true
      },
      {
        name: "Price (Rs)",
        selector: row => formatNumber(row.price)
      },
      // {
      //   name: "Stock",
      //   selector: row => row.product.product_quantity + ' ' + row.product.product_unit
      // },
      {
        name: "Quantity",
        selector: row => row.quantity
      },
      {
        name: "Discount (Rs)",
        selector: row => formatNumber(row.discount_amount)
      },
      {
        name: "Tax (Rs)",
        selector: row => formatNumber(row.product_tax_amount)
      },
      {
        name: "Sub Total (Rs)",
        selector: row => formatNumber(row.sub_total)
      },
    ],
    [rows]
  );

  return (
    <>
      <Link to='/dashboard/sales' className="btn btn-primary" >Back</Link>
      <hr />
      <div style={{ display: "none" }}>
        <SalePOSPrint ref={posPrintRef} formData={formData} rows={rows} businessData={businessData} />
      </div>
      <div className="card shadow mb-4" ref={printableArea}>
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Sale Details</h6>
          Reference: <strong>{formData ? formData.reference : ''}</strong>
          <button className="btn btn-sm btn-secondary mfs-auto mfe-1 d-print-none ml-5" onClick={handlePrint}>
            <i className="bi bi-printer"></i> Print Invoice
          </button>
          <button className="btn btn-sm btn-secondary mfs-auto mfe-1 d-print-none ml-5" onClick={handlePOSPrint}>
            <i className="bi bi-printer"></i> Print POS
          </button>
        </div>
        <div className="card-body">
          <div className="row mb-4">
            <div className="col-sm-4 mb-3 mb-md-0">
              <h5 className="mb-2 border-bottom pb-2">Company Info:</h5>
              <div><strong>{businessData ? businessData.company_name : ''}</strong></div>
              <div>{businessData ? businessData.company_address : ''}</div>
              <div>Email: {businessData ? businessData.company_email : ''}</div>
              <div>Phone: {businessData ? businessData.company_phone : ''}</div>
            </div>

            <div className="col-sm-4 mb-3 mb-md-0">
              <h5 className="mb-2 border-bottom pb-2">Customer Info:</h5>
              <div><strong>{formData ? formData.customer_details.customer_name : ''}</strong></div>
              <div>{formData ? formData.customer_details.address : ''}</div>
              <div>Email: {formData ? formData.customer_details.customer_email : ''}</div>
              <div>Phone: {formData ? formData.customer_details.customer_phone : ''}</div>
            </div>

            <div className="col-sm-4 mb-3 mb-md-0">
              <h5 className="mb-2 border-bottom pb-2">Invoice Info:</h5>
              <div>Invoice: <strong>INV/{formData ? formData.reference : ''}</strong></div>
              <div>Date: {formData ? formData.date : ''}</div>
              <div>
                Status: <strong>{formData ? formData.status : ''}</strong>
              </div>
              <div>
                Payment Method: <strong>{formData ? formData.payment_method : ''}</strong><br />
                Payment Status: <strong>{formData ? formData.payment_status : ''}</strong>
              </div>
            </div>

          </div>
          <div className="table-responsive-sm">
            <DataTable
              title="Products List"
              columns={columns}
              data={rows}
            />
          </div>
          <div className="row">
            <div className="col-lg-4 col-sm-5 ml-md-auto">
              <table className="table">
                <tbody>
                  <tr>
                    <td className="left"><strong>Discount ({formData ? formData.discount_percentage : ''}%) (Rs)</strong></td>
                    <td className="right">{formData ? formData.discount_amount : ''}</td>
                  </tr>
                  <tr>
                    <td className="left"><strong>Tax  ({formData ? formData.tax_percentage : ''}%) (Rs)</strong></td>
                    <td className="right">{formData ? formData.tax_amount : ''}</td>
                  </tr>
                  <tr>
                    <td className="left"><strong>Shipping (Rs)</strong></td>
                    <td className="right">{formData ? formData.shipping_amount : ''}</td>
                  </tr>
                  <tr>
                    <td className="left"><strong>Grand Total (Rs)</strong></td>
                    <td className="right"><strong>{formData ? formData.total_amount : ''}</strong></td>
                  </tr>
                  <tr>
                    <td className="left"><strong>Notes</strong></td>
                    <td className="right"><strong>{formData ? formData.note : ''}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SaleView;